//      https://backend-mvp-a6w0.onrender.com = http://localhost:8000
// src/App.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";
//////////////////////////////////////////////////////////////////////////////
//import Register   from "./Register";
//import VerifyCode from "./VerifyCode";
import AuthForm from "./AuthForm";
////////////////////////////////////////////////////////////////////////////////
// ——— FECHA FIJA PARA EL SIMULACRO ———
/*
const FECHA_INICIO_SIMULACRO = "2025-07-05T23:44:00-05:00";
const FECHA_FIN_SIMULACRO    = "2025-07-05T23:50:00-05:00";
*/
const FECHA_INICIO_SIMULACRO = "2025-07-06T09:00:00-05:00";
const FECHA_FIN_SIMULACRO    = "2025-07-06T11:00:00-05:00";

function App() {
  useEffect(() => {
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");
    if (token && email) {
      setIsAuthenticated(true);
      setUserEmail(email);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);
  // —— ESTADOS GENERALES —— //
  const [cargando, setCargando] = useState(false);
  const [pantalla, setPantalla] = useState("mainInicio");
  // pantallas: mainInicio | diagnostico | bancoTemas | bancoSimulacro | simulacroSimulacro | formulario | resultados
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail]         = useState("");

  // —— ESTADOS PARA DIAGNÓSTICO —— //
  const [numeroPrueba, setNumeroPrueba] = useState(null);
  const [preguntasDiag, setPreguntasDiag] = useState([]);
  const [respuestasDiag, setRespuestasDiag] = useState({});
  const [preguntaActualDiag, setPreguntaActualDiag] = useState(0);
  const [tiempoDiag, setTiempoDiag] = useState(50 * 60);
  const [tiempoInicialDiag] = useState(50 * 60);
  const [tiempoActivoDiag, setTiempoActivoDiag] = useState(false);
  const [resultadosDiag, setResultadosDiag] = useState(null);

  // —— ESTADOS PARA SIMULACRO —— //
  const [preguntasSimu, setPreguntasSimu] = useState([]);
  const [respuestasSimu, setRespuestasSimu] = useState({});
  const [preguntaActualSimu, setPreguntaActualSimu] = useState(0);
  const [tiempoSimu, setTiempoSimu] = useState(0);
  const [tiempoInicialSimu, setTiempoInicialSimu] = useState(0);
  const [tiempoActivoSimu, setTiempoActivoSimu] = useState(false);
  const [resultadosSimu, setResultadosSimu] = useState(null);

  // —— ESTADOS PARA FORMULARIO Y RESULTADOS —— //
  const [datosUsuario, setDatosUsuario] = useState({ nombre: "", correo: "" });
  const [comentarioResultado, setComentarioResultado] = useState("");
  const [tipoPrueba, setTipoPrueba] = useState(""); // "diagnostico" | "simulacro" | "banco"

  // —— ESTADOS PARA HORARIO DEL SIMULACRO —— //
  const [tiempoParaSimulacro, setTiempoParaSimulacro] = useState(null);
  const [puedeIniciarSimulacro, setPuedeIniciarSimulacro] = useState(false);
  const [simulacroExpirado, setSimulacroExpirado] = useState(false);

  // ——— UTIL: Siempre obtener un token fresco de backend ———
  const getToken = async () => {
    try {
      const resp = await axios.get("https://backend-mvp-a6w0.onrender.com/obtener-token/");
      return resp.data.access_token;
    } catch (err) {
      console.error("[App.js] Error obteniendo token:", err);
      return null;
    }
  };

  // —— TEMPORIZADOR PARA DIAGNÓSTICO —— //
  useEffect(() => {
    let intervalo;
    if (tiempoActivoDiag && tiempoDiag > 0 && pantalla === "diagnostico") {
      intervalo = setInterval(() => {
        setTiempoDiag((t) => t - 1);
      }, 1000);
    } else if (tiempoDiag === 0 && pantalla === "diagnostico") {
      finalizarDiagnostico();
    }
    return () => clearInterval(intervalo);
  }, [tiempoActivoDiag, tiempoDiag, pantalla]);

  // —— TEMPORIZADOR PARA SIMULACRO —— //
  useEffect(() => {
    let intervalo;
    if (tiempoActivoSimu && tiempoSimu > 0 && pantalla === "simulacroSimulacro") {
      intervalo = setInterval(() => {
        setTiempoSimu((t) => t - 1);
      }, 1000);
    } else if (tiempoSimu === 0 && pantalla === "simulacroSimulacro") {
      finalizarSimulacro();
    }
    return () => clearInterval(intervalo);
  }, [tiempoActivoSimu, tiempoSimu, pantalla]);

  // —— RENDERIZAR MathJax tras cargar preguntas (Diagnóstico) —— //
  useEffect(() => {
    if (window.MathJax && preguntasDiag.length > 0 && pantalla === "diagnostico") {
      window.MathJax.typesetPromise();
    }
  }, [preguntaActualDiag, preguntasDiag, pantalla]);

  // —— RENDERIZAR MathJax tras cargar preguntas (Simulacro) —— //
  useEffect(() => {
    if (window.MathJax && preguntasSimu.length > 0 && pantalla === "simulacroSimulacro") {
      window.MathJax.typesetPromise();
    }
  }, [preguntaActualSimu, preguntasSimu, pantalla]);

  // —— RENDERIZAR MathJax en Resultados —— //
  useEffect(() => {
    if (pantalla === "resultados" && window.MathJax) {
      window.MathJax.typesetPromise();
    }
  }, [pantalla]);

  
  // —— CÁLCULO DEL ESTADO DEL SIMULACRO (cada segundo), usando FECHA FIJA —— //
  useEffect(() => {
    const calcularEstadoSimulacro = () => {
      const ahora   = new Date();
      const inicioSim = new Date(FECHA_INICIO_SIMULACRO);
      const finSim    = new Date(FECHA_FIN_SIMULACRO);

      if (ahora >= finSim) {
        // Ya pasó la hora de finalización
        setTiempoParaSimulacro(0);
        setPuedeIniciarSimulacro(false);
        setSimulacroExpirado(true);
      } else if (ahora >= inicioSim) {
        // Dentro de la ventana 08:00–10:00 del 22 de junio
        setTiempoParaSimulacro(0);
        setPuedeIniciarSimulacro(true);
        setSimulacroExpirado(false);
      } else {
        // Aún no ha llegado el inicio
        const diffMs = inicioSim - ahora;
        setTiempoParaSimulacro(Math.max(0, Math.floor(diffMs / 1000)));
        setPuedeIniciarSimulacro(false);
        setSimulacroExpirado(false);
      }
    };

    calcularEstadoSimulacro();
    const intervaloEstado = setInterval(calcularEstadoSimulacro, 1000);
    return () => clearInterval(intervaloEstado);
  }, []);

  // —— FUNCIONES AUXILIARES —— //
  const formatoTiempo = (segundos) => {
    const min = Math.floor(segundos / 60);
    const segs = segundos % 60;
    return `${min.toString().padStart(2, "0")}:${segs.toString().padStart(2, "00")}`;
  };

  // Convierte segundos en “X días Y horas Z minutos”
  const formatoTiempoRestante = (totalSegundos) => {
    if (totalSegundos <= 0) return "0 minutos";
    const segsEnDia = 24 * 3600;
    const dias = Math.floor(totalSegundos / segsEnDia);
    const resto1 = totalSegundos - dias * segsEnDia;
    const horas = Math.floor(resto1 / 3600);
    const resto2 = resto1 - horas * 3600;
    const minutos = Math.floor(resto2 / 60);
    let texto = "";
    if (dias > 0) texto += `${dias} día${dias > 1 ? "s" : ""} `;
    if (horas > 0) texto += `${horas} hora${horas > 1 ? "s" : ""} `;
    if (minutos > 0 || texto === "") texto += `${minutos} minuto${minutos > 1 ? "s" : ""}`;
    return texto.trim();
  };

  const mezclarArray = (array) => {
    let currentIndex = array.length, randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
  };

  const calcularPuntajePorCurso = (curso, tipo) => {
    if (tipo === "diagnostico") {
      switch (curso) {
        case "RM": return 0.96;
        case "RV": return 0.96;
        case "Aritmética": return 1.81;
        case "Algebra": return 1.81;
        case "Geometría": return 1.81;
        case "Trigonometría": return 1.81;
        case "Física": return 3.62;
        case "Química": return 2.42;
      }
    } else if (tipo === "simulacro"){
      // Para simulacro
      switch (curso) {
        case "RM" :return 0.48;
        case "RV": return 0.48;
        case "Aritmética": return 0.91;
        case "Algebra": return 0.91;
        case "Geometría": return 0.91;
        case "Trigonometría": return 0.91;
        case "Física": return 0.91;
        case "Química": return 0.60;
      }
    }
  };

  const obtenerComentario = (notaVigesimal) => {
    if (tipoPrueba === "diagnostico") {
      if (notaVigesimal < 10) {
        return "Es necesario fortalecer tu base para el examen de admisión a la UNI. Te animamos a practicar con dedicación y a revisar los conceptos fundamentales.";
      } else if (notaVigesimal < 14) {
        return "Tienes potencial para lograr el ingreso a la UNI, pero se requiere mayor consistencia. Identifica tus áreas de oportunidad y trabaja intensamente en ellas.";
      } else if (notaVigesimal < 18) {
        return "¡Vas por buen camino! Estás demostrando un buen nivel de preparación. Continúa practicando para afianzar tus conocimientos y aumentar tus posibilidades de éxito.";
      } else {
        return "¡Excelente desempeño! Tu preparación te posiciona para competir por los primeros puestos. ¡Sigue así y alcanzarás tus metas!";
      }
    } else {
      return "Los resultados detallados de tu simulacro serán enviados a tu correo electrónico. Revisa tu bandeja de entrada en las próximas horas.";
    }
  };

  const validarFormulario = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return datosUsuario.nombre.trim() !== "" && emailRegex.test(datosUsuario.correo);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDatosUsuario((prev) => ({ ...prev, [name]: value }));
  };

  // —— FLUJO: Prueba de Diagnóstico —— //
    const iniciarDiagnostico = async (num) => {                    // ← ahora recibe `num`
    console.log("Iniciando diagnóstico número:", num);           // ← debug
    setNumeroPrueba(num);
    setTipoPrueba("diagnostico");
    setCargando(true);
    setRespuestasDiag({});
    setResultadosDiag(null);
    setPreguntaActualDiag(0);
    setTiempoDiag(50 * 60);
    setTiempoActivoDiag(true);
    

    try {
      // 1) pedir token fresco
      const token = await getToken();
      if (!token) {
        alert("No se pudo obtener token para diagnóstico. Intenta de nuevo.");
        setPantalla("mainInicio");
        setCargando(false);
        return;
      }

      // 2) llamar a /diagnostico/
      const response = await axios.get(
        `https://backend-mvp-a6w0.onrender.com/diagnostico/?numero=${num}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data && Array.isArray(response.data)) {
        setPreguntasDiag(response.data);
        setPantalla("diagnostico");
      } else {
        console.warn("[App.js] Respuesta inesperada diagnóstico:", response.data);
        if (response.data.error) {
          alert("Error en diagnóstico: " + response.data.error);
        } else {
          alert("No se pudieron cargar las preguntas del diagnóstico.");
        }
        setPantalla("mainInicio");
      }
    } catch (error) {
      console.error("[App.js] Error al obtener preguntas de diagnóstico:", error);
      if (error.response?.data?.detail) {
        alert("Diagnóstico falló: " + error.response.data.detail);
      } else {
        alert("Error al cargar las preguntas del diagnóstico. Intenta nuevamente.");
      }
      setPantalla("mainInicio");
    } finally {
      setCargando(false);
    }
  };

  const seleccionarRespuestaDiag = (ejercicio, letra) => {
    setRespuestasDiag((prev) => ({ ...prev, [ejercicio]: letra }));
  };

  const siguientePreguntaDiag = () => {
    if (preguntaActualDiag < preguntasDiag.length - 1) {
      setPreguntaActualDiag((p) => p + 1);
    }
  };

  const anteriorPreguntaDiag = () => {
    if (preguntaActualDiag > 0) {
      setPreguntaActualDiag((p) => p - 1);
    }
  };

  const finalizarDiagnostico = () => {
    setTiempoActivoDiag(false);
    let nuevosRes = {};
    let correctas = 0;
    let incorrectas = 0;
    let sinResponder = 0;
    let notaTotal = 0;

    preguntasDiag.forEach((p) => {
      const resp = respuestasDiag[p.ejercicio];
      if (!resp) {
        nuevosRes[p.ejercicio] = "Sin responder";
        sinResponder++;
      } else if (resp === p.respuesta_correcta) {
        nuevosRes[p.ejercicio] = "Correcta";
        correctas++;
        notaTotal += calcularPuntajePorCurso(p.curso, "diagnostico");
      } else {
        nuevosRes[p.ejercicio] = `Incorrecta (Resp: ${p.respuesta_correcta})`;
        incorrectas++;
      }
    });

    notaTotal = Math.min(notaTotal, 20);
    const tiempoUsado = tiempoInicialDiag - tiempoDiag;

    setResultadosDiag({
      detalles: nuevosRes,
      correctas,
      incorrectas,
      sinResponder,
      porcentaje: (preguntasDiag.length > 0 ? (correctas / preguntasDiag.length) * 100 : 0),
      notaVigesimal: notaTotal,
      tiempoUsado,
      respuestas: respuestasDiag
    });
    setComentarioResultado(obtenerComentario(notaTotal));
    setPantalla("formulario");
  };

  
  // —— FLUJO: Guardar resultados (Diagnóstico o Simulacro) —— //
  const procesarFormulario = async () => {
    if (!validarFormulario()) {
      alert("Por favor, completa correctamente todos los campos del formulario");
      return;
    }
    setCargando(true);

    try {
      let endpoint = "";
      let payload = {};

      if (tipoPrueba === "diagnostico") {
        endpoint = "https://backend-mvp-a6w0.onrender.com/guardar-diagnostico/";
        payload = {
          nombre: datosUsuario.nombre,
          correo: datosUsuario.correo,
          resultado: resultadosDiag.notaVigesimal,
          preguntas_correctas: resultadosDiag.correctas,
          preguntas_incorrectas: resultadosDiag.incorrectas,
          preguntas_sin_responder: resultadosDiag.sinResponder,
          tiempo_usado: resultadosDiag.tiempoUsado,
        };
      } else if (tipoPrueba === "simulacro") {
        endpoint = "https://backend-mvp-a6w0.onrender.com/guardar-simulacro/";
        payload = {
          nombre: datosUsuario.nombre,
          correo: datosUsuario.correo,
          resultado: resultadosSimu.notaVigesimal,
          preguntas_correctas: resultadosSimu.correctas,
          preguntas_incorrectas: resultadosSimu.incorrectas,
          preguntas_sin_responder: resultadosSimu.sinResponder,
          tiempo_usado: resultadosSimu.tiempoUsado,
          respuestas: JSON.stringify(resultadosSimu.respuestas),
        };
      }

      // NUEVO: Pedir token fresco antes de guardar
      const token = await getToken();
      if (!token) {
        alert("No se pudo obtener token para guardar resultados. Intenta nuevamente.");
        setCargando(false);
        return;
      }

      await axios.post(endpoint, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error("[App.js] Error al guardar resultados:", error);
      alert("Hubo un error guardando tus resultados. Intenta nuevamente.");
    } finally {
      setCargando(false);
      setPantalla("resultados");
    }
  };

  // —— FLUJO: Simulacro —— //
  const iniciarSimulacro = async () => {
    const ahora   = new Date();
    const inicioSim = new Date(FECHA_INICIO_SIMULACRO);
    const finSim    = new Date(FECHA_FIN_SIMULACRO);

    if (ahora < inicioSim) {
      alert(
        `El simulacro comienza el 06 de julio de 2025 a las 09:00 am (hora Perú).`
      );
      return;
    }
    if (ahora >= finSim) {
      alert("El tiempo para iniciar el simulacro ha finalizado.");
      setPuedeIniciarSimulacro(false);
      setSimulacroExpirado(true);
      return;
    }

    const durRestMs  = finSim - ahora;
    const durRestSeg = Math.max(0, Math.floor(durRestMs / 1000));

    setTipoPrueba("simulacro");
    setCargando(true);
    setRespuestasSimu({});
    setResultadosSimu(null);
    setPreguntaActualSimu(0);
    setTiempoSimu(durRestSeg);
    setTiempoInicialSimu(durRestSeg);
    setTiempoActivoSimu(true);
    setPantalla("simulacroSimulacro");

    try {
      // 1) pedir token fresco
      const token = await getToken();
      if (!token) {
        alert("No se pudo obtener token para simulacro. Intenta de nuevo.");
        setPantalla("mainInicio");
        setCargando(false);
        return;
      }

      // 2) llamar a /simulacro/
      const response = await axios.get(
        "https://backend-mvp-a6w0.onrender.com/simulacro/",
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data && Array.isArray(response.data)) {
        setPreguntasSimu(response.data);
      } else {
        console.warn("[App.js] Respuesta inesperada simulacro:", response.data);
        if (response.data.error) {
          alert("Error simulacro: " + response.data.error);
        } else {
          alert("No se pudieron cargar las preguntas del simulacro.");
        }
        setPantalla("mainInicio");
      }
    } catch (error) {
      console.error("[App.js] Error al obtener preguntas de simulacro:", error);
      if (error.response?.data?.detail) {
        alert("Simulacro falló: " + error.response.data.detail);
      } else {
        alert("Error al cargar las preguntas del simulacro. Intenta nuevamente.");
      }
      setPantalla("mainInicio");
    } finally {
      setCargando(false);
    }
  };

  const seleccionarRespuestaSimu = (ejercicio, letra) => {
    setRespuestasSimu((prev) => ({ ...prev, [ejercicio]: letra }));
  };

  const siguientePreguntaSimu = () => {
    if (preguntaActualSimu < preguntasSimu.length - 1) {
      setPreguntaActualSimu((p) => p + 1);
    }
  };

  const anteriorPreguntaSimu = () => {
    if (preguntaActualSimu > 0) {
      setPreguntaActualSimu((p) => p - 1);
    }
  };

  const finalizarSimulacro = () => {
    setTiempoActivoSimu(false);
    let nuevosRes = {};
    let correctas = 0;
    let incorrectas = 0;
    let sinResponder = 0;
    let notaTotal = 0;

    preguntasSimu.forEach((p) => {
      const resp = respuestasSimu[p.ejercicio];
      if (!resp) {
        nuevosRes[p.ejercicio] = "Sin responder";
        sinResponder++;
      } else if (resp === p.respuesta_correcta) {
        nuevosRes[p.ejercicio] = "Correcta";
        correctas++;
        notaTotal += calcularPuntajePorCurso(p.curso, "simulacro");
      } else {
        nuevosRes[p.ejercicio] = `Incorrecta (Resp: ${p.respuesta_correcta})`;
        incorrectas++;
      }
    });

    notaTotal = Math.min(notaTotal, 20);
    const tiempoUsado = tiempoInicialSimu - tiempoSimu;

    setResultadosSimu({
      detalles: nuevosRes,
      correctas,
      incorrectas,
      sinResponder,
      porcentaje: (preguntasSimu.length > 0 ? (correctas / preguntasSimu.length) * 100 : 0),
      notaVigesimal: notaTotal,
      tiempoUsado,
      respuestas: respuestasSimu
    });
    setComentarioResultado(obtenerComentario(notaTotal));
    setPantalla("formulario");
  };

  // —— RENDERIZADO POR PANTALLA —— //
  if (cargando) {
    return (
      <div className="container cargando-container">
        <div className="spinner"></div>
        <p>Un momento, se están cargando todos los ejercicios. Puede tardar entre 20-30 segundos de acuerdo a su conexión</p>
      </div>
    );
  }
 ///////////////////////////////////////////////////////
 // Pantalla ÚNICA de login/registro/verificación
  if (pantalla === "auth") {
    return (
      <AuthForm
        onAuthenticated={(email) => {
          setIsAuthenticated(true);
          setUserEmail(email);
          setPantalla("mainInicio");
        }}
        onBack={() => setPantalla("mainInicio")}
      />
    );
  }
  ///////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  // —— PANTALLA PRINCIPAL ——
  if (pantalla === "mainInicio") {
    return (
      <div className="container main-inicio-container">
        <div className="header-logo">
          <div className="header-logo-mask" aria-hidden="true" />
          <h1 className="header-logo-title">EDBOT</h1>
        </div>
        <p>Preparación preuniversitaria impulsada por IA.</p>
        {/* ——— Si está logueado, saludo y botones personalizados ——— */}
        {isAuthenticated && (
          <div style={{ alignSelf: "flex-end", margin: "10px 0 20px", textAlign: "right" }}>
            <p>👋 Hola, <strong>{userEmail}</strong></p>
            {/* Contenedor nuevo */}
            <div className="user-buttons">
              <button
                className="boton-principal"
                onClick={() => setPantalla("resultadosUsuario")}
              >
                Ver mis resultados
              </button>
              <button
                className="boton-principal"
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("email");
                  setIsAuthenticated(false);
                  setUserEmail("");
                }}
              >
                Cerrar sesión
              </button>
            </div>
          </div>
        )}

        {/* ——— Botón Crear cuenta (cuando NO está logueado) ——— */}
        {!isAuthenticated && (
          <button
            className="boton-principal"
            onClick={() => setPantalla("auth")}
            style={{ alignSelf: "flex-end", margin: "10px 0 20px" }}
          >
            Iniciar sesión / Registrarse
          </button>
        )}
    
        <div className="opciones-container">

          {/* Tarjeta: Simulacro */}
          <div className="opcion-card">
            <h2>Simulacro</h2>
            <p style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#8A1538" }}>
              Próximo simulacro virtual<br/>
              06 de julio. 
            </p>
            <p>Con S/ 10 de inscripción accede al sorteo de<br/>
              1. Pack libros Física Lumbreras<br/>
              2. Libro Aptitud académica Lumbreras<br/>
              <br/>
              Todos los que rindan el simulacro:<br/>
              Mochila + lentes + audífonos
            </p>

            {simulacroExpirado ? (
              <p style={{ fontWeight: "bold", color: "#dc3545" }}>
                El tiempo para iniciar el simulacro ha terminado.
              </p>
            ) : tiempoParaSimulacro !== null && tiempoParaSimulacro > 0 ? (
              <p style={{ fontWeight: "bold", color: "#0d6efd" }}>
                El simulacro comienza en: {formatoTiempoRestante(tiempoParaSimulacro)}
              </p>
            ) : puedeIniciarSimulacro ? (
              <p style={{ fontWeight: "bold", color: "green" }}>
                ¡El simulacro está activo! Finaliza a las 11:00 am (hora Perú).
              </p>
            ) : (
              <p>Verificando horario del simulacro...</p>
            )}

            <button
              className="boton-principal"
              onClick={iniciarSimulacro}
              disabled={!puedeIniciarSimulacro || simulacroExpirado}
            >
              {simulacroExpirado ? "Simulacro Finalizado" : "Comenzar simulacro"}
            </button>
          </div>

          {/* Tarjeta: Prueba de Diagnóstico */}
          <div className="opcion-card">
            <h2>Prueba de diagnóstico</h2>
            <p>
              ¿Te estás preparando para postular a la UNI? En esta sección encontrarás pruebas de diagnóstico que 
              evaluarán tu nivel con 15 ejercicios de exámenes UNI. Dispondrás de 50 minutos.<br/>
              Actualizada al 01/07/2025
            </p>
            <button
              className="boton-principal"
              onClick={() => setPantalla("seleccionarDiagnostico")}
            >
              Comenzar diagnóstico
            </button>
          </div>
  
    
          {/* 3) EDBOT Help */}
          <div className="opcion-card">
            <h2>EDBOT Help</h2>
            <p>
              ¿Tienes ejercicios en los que te gustaría que EDBOT te eche una mano?  
              Con nuestro plan de resolución de ejercicios podrás elegir la opción que mejor se ajuste a tus necesidades:
              <br /><br />
              <strong>A.</strong> 1 ejercicio → S/ 2 (validez 1 día)  
              <br />
              <strong>B.</strong> 7 ejercicios → S/ 10 (validez 1 semana)  
              <br />
              <strong>C.</strong> 30 ejercicios → S/ 30 (validez 1 mes)  
            </p>
            <div className="contact-links">
              <a
                href="https://wa.me/51953373146?text=Hola%20Edbot"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/whatsapp.svg"
                  alt="WhatsApp"
                  className="contact-icon whatsapp-icon"
                />    
                <span>Contactar por WhatsApp</span>
              </a>
            </div>
          </div>

          {/* 4) Contáctanos */}
          <div className="opcion-card">
            <h2>Contáctanos</h2>
            <p>
              En nuestro canal de YouTube encontrarás ejercicios resueltos del material de CEPREUNI. 
              Para cualquier duda, escríbenos un correo y con gusto te responderemos.
            </p>
            <div className="contact-links">
              <a
                href="https://www.youtube.com/@edbotuni"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/youtube.svg"
                  alt="YouTube"
                  className="contact-icon"
                />
                <span>YouTube</span>
              </a>
              <a href="mailto:edbot.uni@gmail.com">
                <img
                  src="https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/gmail.svg"
                  alt="Correo"
                  className="contact-icon"
                />
                <span>edbot.uni@gmail.com</span>
              </a>
            </div>
          </div>
          
        </div>
        
      </div>
    );
  }

  // —— PANTALLA DIAGNÓSTICO ——
  if (pantalla === "diagnostico" && preguntasDiag.length > 0) {
    const p = preguntasDiag[preguntaActualDiag];
    return (
      <div className="container simulacro-container">
        <button
          onClick={() => setPantalla("seleccionarDiagnostico")}
          className="boton-nav"
          style={{ marginBottom: "20px" }}
        >
          ← Volver a pantalla de diagnósticos
        </button>
        <div className="encabezado-simulacro">
          <div className="progreso">
            <div className="texto-progreso">
              Pregunta: {preguntaActualDiag + 1} de {preguntasDiag.length}
            </div>
            <div className="barra-progreso">
              <div
                className="progreso-completado"
                style={{
                  width: `${((preguntaActualDiag + 1) / preguntasDiag.length) * 100}%`,
                }}
              ></div>
            </div>
          </div>
          <div className="temporizador">⏱️ {formatoTiempo(tiempoDiag)}</div>
        </div>
        <div className="pregunta-container" key={p.ejercicio}>
          <p className="ejercicio-texto">
            <span dangerouslySetInnerHTML={{ __html: p.ejercicio }} />
          </p>
          {p.imagen && (
            <img
              src={p.imagen}
              alt="Ejercicio"
              className="imagen-ejercicio"
            />
          )}
          <ul className="opciones-lista">
            {p.alternativas.map((alt) => (
              <li key={alt.letra} className="opcion">
                <label>
                  <input
                    type="radio"
                    name={`pregunta-${p.ejercicio}`}
                    value={alt.letra}
                    checked={respuestasDiag[p.ejercicio] === alt.letra}
                    onChange={() => seleccionarRespuestaDiag(p.ejercicio, alt.letra)}
                  />
                  <span
                    className="texto-opcion"
                    dangerouslySetInnerHTML={{
                      __html: `${alt.letra}) ${alt.texto}`,
                    }}
                  />
                </label>
              </li>
            ))}
          </ul>
        </div>
        <div className="controles-navegacion">
          <button
            className="boton-nav"
            onClick={anteriorPreguntaDiag}
            disabled={preguntaActualDiag === 0}
          >
            Anterior
          </button>
          {preguntaActualDiag === preguntasDiag.length - 1 ? (
            <button
              className="boton-finalizar"
              onClick={finalizarDiagnostico}
            >
              Finalizar diagnóstico
            </button>
          ) : (
            <button className="boton-nav" onClick={siguientePreguntaDiag}>
              Siguiente
            </button>
          )}
        </div>
      </div>
    );
  }


  // ← CAMBIO: nueva pantalla para elegir Prueba 1 o 2
  if (pantalla === "seleccionarDiagnostico") {
    return (
      <div className="container main-inicio-container">
        <button className="boton-nav" onClick={() => setPantalla("mainInicio")}>
          ← Volver al inicio
        </button>
        <div className="opciones-container">
          {/* Prueba 1 */}
          <div className="opcion-card">
            <h2>Prueba de diagnóstico 1</h2>
            <p>15 ejercicios de examen UNI.<br/>50 minutos.<br/>Actualizado el 01/06/2025</p>
            <button
              className="boton-principal"
              onClick={() => iniciarDiagnostico(1)}                // ← pasamos 1
            >
              Iniciar Prueba 1
            </button>
          </div>
          {/* Prueba 2 */}
          <div className="opcion-card">
            <h2>Prueba de diagnóstico 2</h2>
            <p>15 ejercicios de examen UNI.<br/>50 minutos.<br/>Actualizado el 01/07/2025</p>
            <button
              className="boton-principal"
              onClick={() => iniciarDiagnostico(2)}                // ← pasamos 2
            >
              Iniciar Prueba 2
            </button>
          </div>
        </div>
      </div>
    );
  }


  // —— PANTALLA SIMULACRO: Resolución ——
  if (pantalla === "simulacroSimulacro" && preguntasSimu.length > 0) {
    const p = preguntasSimu[preguntaActualSimu];
    const respSel = respuestasSimu[p.ejercicio];
    return (
      <div className="container simulacro-container">
        <div className="encabezado-simulacro">
          <div className="progreso">
            <div className="texto-progreso">
              Pregunta: {preguntaActualSimu + 1} de {preguntasSimu.length}
            </div>
            <div className="barra-progreso">
              <div
                className="progreso-completado"
                style={{
                  width: `${((preguntaActualSimu + 1) / preguntasSimu.length) * 100}%`,
                }}
              ></div>
            </div>
          </div>
          <div className="temporizador">⏱️ {formatoTiempo(tiempoSimu)}</div>
        </div>
        <div className="pregunta-container" key={p.ejercicio}>
          <p className="ejercicio-texto">
            <span dangerouslySetInnerHTML={{ __html: p.ejercicio }} />
          </p>
          {p.imagen && (
            <img src={p.imagen} alt="Ejercicio" className="imagen-ejercicio" />
          )}
          <ul className="opciones-lista">
            {p.alternativas.map((alt) => (
              <li key={alt.letra} className="opcion">
                <label>
                  <input
                    type="radio"
                    name={`pregunta-simu-${p.ejercicio}`}
                    value={alt.letra}
                    checked={respSel === alt.letra}
                    onChange={() => seleccionarRespuestaSimu(p.ejercicio, alt.letra)}
                  />
                  <span
                    className="texto-opcion"
                    dangerouslySetInnerHTML={{
                      __html: `${alt.letra}) ${alt.texto}`,
                    }}
                  />
                </label>
              </li>
            ))}
          </ul>
        </div>
        <div className="controles-navegacion">
          <button
            className="boton-nav"
            onClick={anteriorPreguntaSimu}
            disabled={preguntaActualSimu === 0}
          >
            Anterior
          </button>
          {preguntaActualSimu === preguntasSimu.length - 1 ? (
            <button className="boton-finalizar" onClick={finalizarSimulacro}>
              Finalizar simulacro
            </button>
          ) : (
            <button className="boton-nav" onClick={siguientePreguntaSimu}>
              Siguiente
            </button>
          )}
        </div>
      </div>
    );
  }

  // —— PANTALLA FORMULARIO (Diagnóstico, Banco o Simulacro) —— //
  if (pantalla === "formulario") {
    return (
      <div className="container formulario-container">
        <h1>
          {tipoPrueba === "diagnostico"
            ? "¡Prueba diagnóstica completada!"
            : tipoPrueba === "simulacro"
            ? "¡Simulacro completado!"
            :""}
        </h1>
        <div className="formulario-content">
          <p>
            Por favor, completa tus datos para{" "}
            {tipoPrueba === "diagnostico"
              ? "ver tus resultados"
              : tipoPrueba === "simulacro"
              ? "recibir tus resultados por correo"
              : ""}
            :
          </p>
          <form className="formulario-registro" onSubmit={(e) => e.preventDefault()}>
            <div className="campo-formulario">
              <label htmlFor="nombre">Nombre completo:</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={datosUsuario.nombre}
                onChange={handleInputChange}
                placeholder="Ingresa tu nombre completo"
                required
              />
            </div>
            <div className="campo-formulario">
              <label htmlFor="correo">Correo electrónico:</label>
              <input
                type="email"
                id="correo"
                name="correo"
                value={datosUsuario.correo}
                onChange={handleInputChange}
                placeholder="Ingresa tu correo electrónico"
                required
              />
            </div>
            <div className="formulario-info">
              <p>
                Estos datos nos permitirán{" "}
                {tipoPrueba === "diagnostico"
                  ? "mostrar tus resultados y recomendaciones"
                  : tipoPrueba === "simulacro"
                  ? "enviarte los resultados del simulacro"
                  :""}
                .
              </p>
            </div>
            <button
              type="button"
              className="boton-ver-resultados"
              onClick={procesarFormulario}
              disabled={!validarFormulario() || cargando}
            >
              {cargando
                ? "Procesando..."
                : tipoPrueba === "diagnostico"
                ? "Ver mis resultados"
                : "Enviar mis resultados"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // —— PANTALLA RESULTADOS —— //
  if (pantalla === "resultados") {
    const resultados =
      tipoPrueba === "diagnostico"
        ? resultadosDiag
        : tipoPrueba === "simulacro"
        ? resultadosSimu
        : null;

    if (!resultados) {
      return (
        <div className="container cargando-container">
          <div className="spinner"></div>
          <p>Cargando resultados...</p>
        </div>
      );
    }

    return (
      <div className="container resultados-container">
        <h1>
          {tipoPrueba === "diagnostico"
            ? "Resultados del Diagnóstico"
            : tipoPrueba === "simulacro"
            ? "Simulacro Completado"
            : ""}
        </h1>

        {tipoPrueba === "diagnostico" && (
          <>
            <div className="datos-usuario">
              <p>
                <strong>Nombre:</strong> {datosUsuario.nombre}
              </p>
              <p>
                <strong>Correo:</strong> {datosUsuario.correo}
              </p>
              {resultados.tiempoUsado !== undefined && (
                <p>
                  <strong>Tiempo utilizado:</strong> {formatoTiempo(resultados.tiempoUsado)}
                </p>
              )}
            </div>

            <div className="resumen-resultados">
              <div className="estadistica correcta">
                <div className="valor">{resultados.correctas}</div>
                <div className="etiqueta">Correctas</div>
              </div>
              <div className="estadistica incorrecta">
                <div className="valor">{resultados.incorrectas}</div>
                <div className="etiqueta">Incorrectas</div>
              </div>
              <div className="estadistica">
                <div className="valor">{resultados.sinResponder}</div>
                <div className="etiqueta">Sin responder</div>
              </div>
              <div className="estadistica">
                <div className="valor">
                  {resultados.notaVigesimal !== undefined
                    ? resultados.notaVigesimal.toFixed(1)
                    : "N/A"}
                </div>
                <div className="etiqueta">Nota (0-20)</div>
              </div>
            </div>

            <div className="comentario-resultado">
              <h2>Evaluación de tu desempeño</h2>
              <p>{comentarioResultado}</p>
            </div>

            <h2>Detalle de respuestas</h2>
            <div className="lista-detalles">
              {preguntasDiag.map((p, i) => {
                const respUsuario = resultados.respuestas[p.ejercicio];
                const estado = !respUsuario
                  ? "sin-responder"
                  : respUsuario === p.respuesta_correcta
                  ? "correcta"
                  : "incorrecta";
                return (
                  <div key={p.ejercicio} className={`detalle-pregunta ${estado}`}>
                    <div className="numero-pregunta">{i + 1}</div>
                    <div className="contenido-detalle">
                      <div
                        className="texto-ejercicio"
                        dangerouslySetInnerHTML={{ __html: p.ejercicio }}
                      ></div>
                      <div className="respuesta-detalle">
                        {!respUsuario ? (
                          <span className="estado-respuesta sin-responder">Sin responder</span>
                        ) : respUsuario === p.respuesta_correcta ? (
                          <span className="estado-respuesta correcta">
                            Correcta: {p.respuesta_correcta} (
                            {calcularPuntajePorCurso(p.curso, "diagnostico")} pts)
                          </span>
                        ) : (
                          <span className="estado-respuesta incorrecta">
                            Incorrecta: Elegiste {respUsuario}, Correcta: {p.respuesta_correcta}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {tipoPrueba === "simulacro" && (
          <div className="comentario-resultado">
            <h2>¡Simulacro completado con éxito!</h2>
            <p>{comentarioResultado}</p>
            <p>
              Hemos registrado tus respuestas y calculado tu puntaje. Los resultados detallados,
              incluyendo tu desempeño por áreas y recomendaciones personalizadas, serán enviados
              a tu correo electrónico en las próximas horas.
            </p>
          </div>
        )}

        <button
          className="boton-reiniciar"
          onClick={() => {
            setPantalla("mainInicio");
            // Reiniciar todos los estados
            setPreguntasDiag([]);
            setRespuestasDiag({});
            setResultadosDiag(null);
            setTiempoDiag(50 * 60);
            setTiempoActivoDiag(false);

            setPreguntasSimu([]);
            setRespuestasSimu({});
            setResultadosSimu(null);
            setTiempoSimu(0);
            setTiempoActivoSimu(false);

            setDatosUsuario({ nombre: "", correo: "" });
            setComentarioResultado("");
            setTipoPrueba("");

            setTiempoParaSimulacro(null);
            setPuedeIniciarSimulacro(false);
            setSimulacroExpirado(false);
          }}
        >
          Volver al inicio
        </button>
      </div>
    );
  }

  // —— Fallback: cargando aplicación —— 
  return (
    <div className="container cargando-container">
      <div className="spinner"></div>
      <p>Cargando aplicación...</p>
    </div>
  );
}

export default App;
